import { colors } from '@ardoq/design-tokens';
import { HtmlCanvasVisual, IRenderContext } from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_OPEN_GROUP_SUBLABEL_FONT as FONT,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';

class GroupSubLabelVisual extends HtmlCanvasVisual {
  constructor(
    private x: number,
    private y: number,
    private wrappedSubLabel: string[],
    private isTransparentized: boolean
  ) {
    super();
  }
  override render(
    _renderContext: IRenderContext,
    ctx: CanvasRenderingContext2D
  ): void {
    const globalAlpha = ctx.globalAlpha;
    if (this.isTransparentized) {
      ctx.globalAlpha = 0.32;
    }
    ctx.font = FONT;
    ctx.fillStyle = colors.grey500;
    const textBaseline = ctx.textBaseline;
    const textAlign = ctx.textAlign;
    ctx.textAlign = 'start';
    ctx.textBaseline = 'top';
    this.wrappedSubLabel.forEach((line, lineIndex) => {
      const lineY = this.y + LINE_HEIGHT * lineIndex;
      ctx.fillText(line, this.x, lineY);
    });
    ctx.textBaseline = textBaseline;
    ctx.textAlign = textAlign;
    ctx.globalAlpha = globalAlpha;
  }
}
export { GroupSubLabelVisual };
